import { useMemo, useCallback, useEffect, useState } from 'react'
import { useIsSsr } from '../../isSsr'
import { HistoryEvents, getSearchParams } from '../utils'

export const useParams = () => {
  const [href, setHref] = useState('')
  const isSsr = useIsSsr()

  const params = useMemo(() => (href ? getSearchParams(href) : null), [href])

  const onHistoryChange = useCallback(() => {
    if (window.location.href !== href) {
      setHref(window.location.href)
    }
  }, [href])

  useEffect(() => {
    if (!isSsr) {
      setHref(window.location.href)

      window.addEventListener(HistoryEvents.PushState, onHistoryChange, false)
      window.addEventListener(
        HistoryEvents.ReplaceState,
        onHistoryChange,
        false
      )
      return () => {
        window.removeEventListener(
          HistoryEvents.PushState,
          onHistoryChange,
          false
        )
        window.removeEventListener(
          HistoryEvents.ReplaceState,
          onHistoryChange,
          false
        )
      }
    }
    return () => {}
  }, [onHistoryChange, isSsr])

  return params
}
